// import { USER_ROLES } from "../../../constant/roles";

export const MenuList = [
  //Dashboard
  {
    title: "Dashboard",
    to: "dashboard",
    //roles: [USER_ROLES.ADMIN, USER_ROLES.ACCOUNT_MANAGER],
    moduleName: "dashboard",
    classsChange: "mm-collapse",
    iconStyle: (
      <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#5f6368'>
        <path d='M520-600v-240h320v240H520ZM120-440v-400h320v400H120Zm400 320v-400h320v400H520Zm-400 0v-240h320v240H120Zm80-400h160v-240H200v240Zm400 320h160v-240H600v240Zm0-480h160v-80H600v80ZM200-200h160v-80H200v80Zm160-320Zm240-160Zm0 240ZM360-280Z' />
      </svg>
    ),
    iconStyleActive: (
      <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#f6f6f6'>
        <path d='M520-600v-240h320v240H520ZM120-440v-400h320v400H120Zm400 320v-400h320v400H520Zm-400 0v-240h320v240H120Zm80-400h160v-240H200v240Zm400 320h160v-240H600v240Zm0-480h160v-80H600v80ZM200-200h160v-80H200v80Zm160-320Zm240-160Zm0 240ZM360-280Z' />
      </svg>
    ),
  },
  //Users
  {
    title: "Users",
    to: "users",
    // roles: [USER_ROLES.ADMIN, USER_ROLES.ACCOUNT_MANAGER],
    moduleName: "employee_onboard",
    classsChange: "mm-collapse",
    iconStyle: (
      <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#5f6368'>
        <path d='M40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm720 0v-120q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v120H760ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z' />
      </svg>
    ),
    iconStyleActive: (
      <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#f6f6f6'>
        <path d='M40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm720 0v-120q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v120H760ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z' />
      </svg>
    ),
  },
  {
    title: "Roles",
    to: "roles",
    // roles: [USER_ROLES.ADMIN, USER_ROLES.ACCOUNT_MANAGER],
    moduleName: "roles",
    classsChange: "mm-collapse",
    iconStyle: (
      <svg width='24' height='24' viewBox='0 0 24 24' fill='#5f6368' xmlns='http://www.w3.org/2000/svg'>
        <path d='M2.4 24C1.74 24 1.175 23.765 0.705 23.295C0.235 22.825 0 22.26 0 21.6V8.4C0 7.74 0.235 7.175 0.705 6.705C1.175 6.235 1.74 6 2.4 6H8.4V2.4C8.4 1.74 8.635 1.175 9.105 0.705C9.575 0.235 10.14 0 10.8 0H13.2C13.86 0 14.425 0.235 14.895 0.705C15.365 1.175 15.6 1.74 15.6 2.4V6H21.6C22.26 6 22.825 6.235 23.295 6.705C23.765 7.175 24 7.74 24 8.4V21.6C24 22.26 23.765 22.825 23.295 23.295C22.825 23.765 22.26 24 21.6 24H2.4ZM2.4 21.6H21.6V8.4H15.6C15.6 9.06 15.365 9.625 14.895 10.095C14.425 10.565 13.86 10.8 13.2 10.8H10.8C10.14 10.8 9.575 10.565 9.105 10.095C8.635 9.625 8.4 9.06 8.4 8.4H2.4V21.6ZM4.8 19.2H12V18.66C12 18.32 11.905 18.005 11.715 17.715C11.525 17.425 11.26 17.2 10.92 17.04C10.52 16.86 10.115 16.725 9.705 16.635C9.295 16.545 8.86 16.5 8.4 16.5C7.94 16.5 7.505 16.545 7.095 16.635C6.685 16.725 6.28 16.86 5.88 17.04C5.54 17.2 5.275 17.425 5.085 17.715C4.895 18.005 4.8 18.32 4.8 18.66V19.2ZM14.4 17.4H19.2V15.6H14.4V17.4ZM8.4 15.6C8.9 15.6 9.325 15.425 9.675 15.075C10.025 14.725 10.2 14.3 10.2 13.8C10.2 13.3 10.025 12.875 9.675 12.525C9.325 12.175 8.9 12 8.4 12C7.9 12 7.475 12.175 7.125 12.525C6.775 12.875 6.6 13.3 6.6 13.8C6.6 14.3 6.775 14.725 7.125 15.075C7.475 15.425 7.9 15.6 8.4 15.6ZM14.4 13.8H19.2V12H14.4V13.8ZM10.8 8.4H13.2V2.4H10.8V8.4Z' />
      </svg>
    ),
    iconStyleActive: (
      <svg width='24' height='24' viewBox='0 0 24 24' fill='#f6f6f6' xmlns='http://www.w3.org/2000/svg'>
        <path d='M2.4 24C1.74 24 1.175 23.765 0.705 23.295C0.235 22.825 0 22.26 0 21.6V8.4C0 7.74 0.235 7.175 0.705 6.705C1.175 6.235 1.74 6 2.4 6H8.4V2.4C8.4 1.74 8.635 1.175 9.105 0.705C9.575 0.235 10.14 0 10.8 0H13.2C13.86 0 14.425 0.235 14.895 0.705C15.365 1.175 15.6 1.74 15.6 2.4V6H21.6C22.26 6 22.825 6.235 23.295 6.705C23.765 7.175 24 7.74 24 8.4V21.6C24 22.26 23.765 22.825 23.295 23.295C22.825 23.765 22.26 24 21.6 24H2.4ZM2.4 21.6H21.6V8.4H15.6C15.6 9.06 15.365 9.625 14.895 10.095C14.425 10.565 13.86 10.8 13.2 10.8H10.8C10.14 10.8 9.575 10.565 9.105 10.095C8.635 9.625 8.4 9.06 8.4 8.4H2.4V21.6ZM4.8 19.2H12V18.66C12 18.32 11.905 18.005 11.715 17.715C11.525 17.425 11.26 17.2 10.92 17.04C10.52 16.86 10.115 16.725 9.705 16.635C9.295 16.545 8.86 16.5 8.4 16.5C7.94 16.5 7.505 16.545 7.095 16.635C6.685 16.725 6.28 16.86 5.88 17.04C5.54 17.2 5.275 17.425 5.085 17.715C4.895 18.005 4.8 18.32 4.8 18.66V19.2ZM14.4 17.4H19.2V15.6H14.4V17.4ZM8.4 15.6C8.9 15.6 9.325 15.425 9.675 15.075C10.025 14.725 10.2 14.3 10.2 13.8C10.2 13.3 10.025 12.875 9.675 12.525C9.325 12.175 8.9 12 8.4 12C7.9 12 7.475 12.175 7.125 12.525C6.775 12.875 6.6 13.3 6.6 13.8C6.6 14.3 6.775 14.725 7.125 15.075C7.475 15.425 7.9 15.6 8.4 15.6ZM14.4 13.8H19.2V12H14.4V13.8ZM10.8 8.4H13.2V2.4H10.8V8.4Z' />
      </svg>
    ),
    // iconStyle: <i className='flaticon-settings' />,
  },

  //Customers
  {
    title: "Customers",
    to: "customers",
    // roles: [USER_ROLES.ADMIN, USER_ROLES.ACCOUNT_MANAGER],
    moduleName: "customers",
    classsChange: "mm-collapse",
    // update: "New",
    iconStyle: (
      <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#5f6368'>
        <path d='M160-40v-80h640v80H160Zm0-800v-80h640v80H160Zm320 400q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm70-80q45-56 109-88t141-32q77 0 141 32t109 88h70v-480H160v480h70Zm118 0h264q-29-20-62.5-30T480-280q-36 0-69.5 10T348-240Zm132-280q-17 0-28.5-11.5T440-560q0-17 11.5-28.5T480-600q17 0 28.5 11.5T520-560q0 17-11.5 28.5T480-520Zm0 40Z' />
      </svg>
    ),
    iconStyleActive: (
      <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#f6f6f6'>
        <path d='M160-40v-80h640v80H160Zm0-800v-80h640v80H160Zm320 400q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm70-80q45-56 109-88t141-32q77 0 141 32t109 88h70v-480H160v480h70Zm118 0h264q-29-20-62.5-30T480-280q-36 0-69.5 10T348-240Zm132-280q-17 0-28.5-11.5T440-560q0-17 11.5-28.5T480-600q17 0 28.5 11.5T520-560q0 17-11.5 28.5T480-520Zm0 40Z' />
      </svg>
    ),
  },
  //Transactions
  {
    title: "Transactions",
    // roles: [USER_ROLES.ADMIN, USER_ROLES.ACCOUNT_MANAGER],
    moduleName: "transactions",
    to: "transactions",
    classsChange: "mm-collapse",
    // update:"New",
    iconStyle: (
      <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#5f6368'>
        <path d='M240-80q-50 0-85-35t-35-85v-120h120v-560l60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60v680q0 50-35 85t-85 35H240Zm480-80q17 0 28.5-11.5T760-200v-560H320v440h360v120q0 17 11.5 28.5T720-160ZM360-600v-80h240v80H360Zm0 120v-80h240v80H360Zm320-120q-17 0-28.5-11.5T640-640q0-17 11.5-28.5T680-680q17 0 28.5 11.5T720-640q0 17-11.5 28.5T680-600Zm0 120q-17 0-28.5-11.5T640-520q0-17 11.5-28.5T680-560q17 0 28.5 11.5T720-520q0 17-11.5 28.5T680-480ZM240-160h360v-80H200v40q0 17 11.5 28.5T240-160Zm-40 0v-80 80Z' />
      </svg>
    ),
    iconStyleActive: (
      <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#f6f6f6'>
        <path d='M240-80q-50 0-85-35t-35-85v-120h120v-560l60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60v680q0 50-35 85t-85 35H240Zm480-80q17 0 28.5-11.5T760-200v-560H320v440h360v120q0 17 11.5 28.5T720-160ZM360-600v-80h240v80H360Zm0 120v-80h240v80H360Zm320-120q-17 0-28.5-11.5T640-640q0-17 11.5-28.5T680-680q17 0 28.5 11.5T720-640q0 17-11.5 28.5T680-600Zm0 120q-17 0-28.5-11.5T640-520q0-17 11.5-28.5T680-560q17 0 28.5 11.5T720-520q0 17-11.5 28.5T680-480ZM240-160h360v-80H200v40q0 17 11.5 28.5T240-160Zm-40 0v-80 80Z' />
      </svg>
    ),
    // content: [
    //   {
    //     title: "All",
    //     to: "transactions",
    //   },
    //   {
    //     title: "Gift",
    //     to: "gift",
    //   },
    //   {
    //     title: "Redeem",
    //     to: "redeem",
    //   },
    //   {
    //     title: "Rewards",
    //     to: "rewards",
    //   },
    //   // {
    //   //   title: "Orders",
    //   //   to: "orders",
    //   // },
    // ],
  },
  {
    title: "Reports",
    // roles: [USER_ROLES.ADMIN, USER_ROLES.ACCOUNT_MANAGER],
    moduleName: "reports",
    classsChange: "mm-collapse",
    iconStyle: (
      <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#5f6368'>
        <path d='M320-600q17 0 28.5-11.5T360-640q0-17-11.5-28.5T320-680q-17 0-28.5 11.5T280-640q0 17 11.5 28.5T320-600Zm0 160q17 0 28.5-11.5T360-480q0-17-11.5-28.5T320-520q-17 0-28.5 11.5T280-480q0 17 11.5 28.5T320-440Zm0 160q17 0 28.5-11.5T360-320q0-17-11.5-28.5T320-360q-17 0-28.5 11.5T280-320q0 17 11.5 28.5T320-280ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h440l200 200v440q0 33-23.5 56.5T760-120H200Zm0-80h560v-400H600v-160H200v560Zm0-560v160-160 560-560Z' />
      </svg>
    ),
    iconStyleActive: (
      <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#f6f6f6'>
        <path d='M320-600q17 0 28.5-11.5T360-640q0-17-11.5-28.5T320-680q-17 0-28.5 11.5T280-640q0 17 11.5 28.5T320-600Zm0 160q17 0 28.5-11.5T360-480q0-17-11.5-28.5T320-520q-17 0-28.5 11.5T280-480q0 17 11.5 28.5T320-440Zm0 160q17 0 28.5-11.5T360-320q0-17-11.5-28.5T320-360q-17 0-28.5 11.5T280-320q0 17 11.5 28.5T320-280ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h440l200 200v440q0 33-23.5 56.5T760-120H200Zm0-80h560v-400H600v-160H200v560Zm0-560v160-160 560-560Z' />
      </svg>
    ),
    content: [
      {
        title: "Daily Customer Point",
        to: "dailyPoint",
      },
      {
        title: "Reward Redemption",
        to: "rewardRedemption",
      },
      {
        title: "Subscribed Customer",
        to: "subscribedCustomerReport",
      },
      {
        // title: "Business-Customer Transactions ",
        title: "Daily Customer Report",
        to: "dailyCustomerReport",
      },
      {
        title: "Transaction",
        hasMenu: true,
        content: [
          {
            title: "Store Purchase",
            to: "storePurchase",
          },
          {
            title: "Subscription",
            to: "Subscription",
          },
          {
            title: "Gift/ Redeem / Reward", //Gift/ Redeem / Reward
            to: "transactionReport",
          },
        ],
      },
    ],
  },
  //Notification
  {
    title: "Notifications",
    to: "notification",
    // roles: [USER_ROLES.ADMIN, USER_ROLES.ACCOUNT_MANAGER],
    moduleName: "notifications",
    classsChange: "mm-collapse",
    iconStyle: (
      <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#5f6368'>
        <path d='M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160Zm320-300Zm0 420q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM320-280h320v-280q0-66-47-113t-113-47q-66 0-113 47t-47 113v280Z' />
      </svg>
    ),
    iconStyleActive: (
      <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#f6f6f6'>
        <path d='M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160Zm320-300Zm0 420q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM320-280h320v-280q0-66-47-113t-113-47q-66 0-113 47t-47 113v280Z' />
      </svg>
    ),
  },

  // In-store request
  {
    title: "In-store Redeem",
    // roles: [USER_ROLES.ADMIN, USER_ROLES.ACCOUNT_MANAGER],
    moduleName: "redeem_requests",
    to: "redeem_requests",
    classsChange: "mm-collapse",
    // update:"New",
    iconStyle: (
      <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#5f6368'>
        <path d='M240-80q-50 0-85-35t-35-85v-120h120v-560l60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60v680q0 50-35 85t-85 35H240Zm480-80q17 0 28.5-11.5T760-200v-560H320v440h360v120q0 17 11.5 28.5T720-160ZM360-600v-80h240v80H360Zm0 120v-80h240v80H360Zm320-120q-17 0-28.5-11.5T640-640q0-17 11.5-28.5T680-680q17 0 28.5 11.5T720-640q0 17-11.5 28.5T680-600Zm0 120q-17 0-28.5-11.5T640-520q0-17 11.5-28.5T680-560q17 0 28.5 11.5T720-520q0 17-11.5 28.5T680-480ZM240-160h360v-80H200v40q0 17 11.5 28.5T240-160Zm-40 0v-80 80Z' />
      </svg>
    ),
    iconStyleActive: (
      <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#f6f6f6'>
        <path d='M240-80q-50 0-85-35t-35-85v-120h120v-560l60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60v680q0 50-35 85t-85 35H240Zm480-80q17 0 28.5-11.5T760-200v-560H320v440h360v120q0 17 11.5 28.5T720-160ZM360-600v-80h240v80H360Zm0 120v-80h240v80H360Zm320-120q-17 0-28.5-11.5T640-640q0-17 11.5-28.5T680-680q17 0 28.5 11.5T720-640q0 17-11.5 28.5T680-600Zm0 120q-17 0-28.5-11.5T640-520q0-17 11.5-28.5T680-560q17 0 28.5 11.5T720-520q0 17-11.5 28.5T680-480ZM240-160h360v-80H200v40q0 17 11.5 28.5T240-160Zm-40 0v-80 80Z' />
      </svg>
    ),
    
  },

  //Settings
  // {
  //   title: "Settings",
  //   //  roles: [USER_ROLES.ADMIN, USER_ROLES.ACCOUNT_MANAGER],
  //   moduleName: "settings",
  //   classsChange: "mm-collapse",
  //   iconStyle: (
  //     <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#5f6368'>
  //       <path d='m370-80-16-128q-13-5-24.5-12T307-235l-119 50L78-375l103-78q-1-7-1-13.5v-27q0-6.5 1-13.5L78-585l110-190 119 50q11-8 23-15t24-12l16-128h220l16 128q13 5 24.5 12t22.5 15l119-50 110 190-103 78q1 7 1 13.5v27q0 6.5-2 13.5l103 78-110 190-118-50q-11 8-23 15t-24 12L590-80H370Zm70-80h79l14-106q31-8 57.5-23.5T639-327l99 41 39-68-86-65q5-14 7-29.5t2-31.5q0-16-2-31.5t-7-29.5l86-65-39-68-99 42q-22-23-48.5-38.5T533-694l-13-106h-79l-14 106q-31 8-57.5 23.5T321-633l-99-41-39 68 86 64q-5 15-7 30t-2 32q0 16 2 31t7 30l-86 65 39 68 99-42q22 23 48.5 38.5T427-266l13 106Zm42-180q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Zm-2-140Z' />
  //     </svg>
  //   ),
  //   iconStyleActive: (
  //     <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#f6f6f6'>
  //       <path d='m370-80-16-128q-13-5-24.5-12T307-235l-119 50L78-375l103-78q-1-7-1-13.5v-27q0-6.5 1-13.5L78-585l110-190 119 50q11-8 23-15t24-12l16-128h220l16 128q13 5 24.5 12t22.5 15l119-50 110 190-103 78q1 7 1 13.5v27q0 6.5-2 13.5l103 78-110 190-118-50q-11 8-23 15t-24 12L590-80H370Zm70-80h79l14-106q31-8 57.5-23.5T639-327l99 41 39-68-86-65q5-14 7-29.5t2-31.5q0-16-2-31.5t-7-29.5l86-65-39-68-99 42q-22-23-48.5-38.5T533-694l-13-106h-79l-14 106q-31 8-57.5 23.5T321-633l-99-41-39 68 86 64q-5 15-7 30t-2 32q0 16 2 31t7 30l-86 65 39 68 99-42q22 23 48.5 38.5T427-266l13 106Zm42-180q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Zm-2-140Z' />
  //     </svg>
  //   ),
  //   // iconStyle: <i className='flaticon-settings' />,
  //   content: [
  //     {
  //       title: "Profile",
  //       to: "app-profile",
  //     },
  //     // {
  //     //   title: "Edit Profile",
  //     //   to: "edit-profile",
  //     // },
  //     // {
  //     //   title: "Invoice",
  //     //   to: "ecom-invoice",
  //     // },
  //     // {
  //     //   title: "Shop",
  //     //   //to: './',
  //     //   hasMenu: true,
  //     //   content: [
  //     //     // {
  //     //     //   title: "Product Grid",
  //     //     //   to: "ecom-product-grid",
  //     //     // },
  //     //     // {
  //     //     //   title: "Product List",
  //     //     //   to: "ecom-product-list",
  //     //     // },
  //     //     // {
  //     //     //   title: "Product Details",
  //     //     //   to: "ecom-product-detail",
  //     //     // },
  //     //     // {
  //     //     //   title: "Order",
  //     //     //   to: "ecom-product-order",
  //     //     // },
  //     //     // {
  //     //     //   title: "Checkout",
  //     //     //   to: "ecom-checkout",
  //     //     // },

  //     //     // {
  //     //     //   title: "Customers",
  //     //     //   to: "ecom-customers",
  //     //     // },
  //     //   ],
  //     // },
  //   ],
  // },

  // {
  //   title: "Audit Logs",
  //   roles: [USER_ROLES.ADMIN, USER_ROLES.ACCOUNT_MANAGER],
  //   classsChange: "mm-collapse",
  //   iconStyle: (
  //     <svg width='19px' height='24px' viewBox='0 0 24 24' fill='#5f6368' xmlns='http://www.w3.org/2000/svg'>
  //       <path d='M2.66667 21.3333H21.3333V9.1L14.9 2.66667H2.66667V21.3333ZM2.66667 24C1.93333 24 1.30556 23.7389 0.783333 23.2167C0.261111 22.6944 0 22.0667 0 21.3333V2.66667C0 1.93333 0.261111 1.30556 0.783333 0.783333C1.30556 0.261111 1.93333 0 2.66667 0H16L24 8V21.3333C24 22.0667 23.7389 22.6944 23.2167 23.2167C22.6944 23.7389 22.0667 24 21.3333 24H2.66667ZM5.33333 18.6667H18.6667V16H5.33333V18.6667ZM5.33333 13.3333H18.6667V10.6667H5.33333V13.3333ZM5.33333 8H14.6667V5.33333H5.33333V8Z' />
  //     </svg>
  //   ),
  //   iconStyleActive: (
  //     <svg width='19px' height='24px' viewBox='0 0 24 24' fill='#f6f6f6' xmlns='http://www.w3.org/2000/svg'>
  //       <path d='M2.66667 21.3333H21.3333V9.1L14.9 2.66667H2.66667V21.3333ZM2.66667 24C1.93333 24 1.30556 23.7389 0.783333 23.2167C0.261111 22.6944 0 22.0667 0 21.3333V2.66667C0 1.93333 0.261111 1.30556 0.783333 0.783333C1.30556 0.261111 1.93333 0 2.66667 0H16L24 8V21.3333C24 22.0667 23.7389 22.6944 23.2167 23.2167C22.6944 23.7389 22.0667 24 21.3333 24H2.66667ZM5.33333 18.6667H18.6667V16H5.33333V18.6667ZM5.33333 13.3333H18.6667V10.6667H5.33333V13.3333ZM5.33333 8H14.6667V5.33333H5.33333V8Z' />
  //     </svg>
  //   ),
  //   to: "audit-logs",
  // },
];
